import Container from './ActionLogFilters.container';
import ActionLogFilters from './ActionLogFilters';

export default Container(ActionLogFilters);
